import { useEffect } from "react";

import { useDebounce, useGetWorkOrderData } from "../../hooks";
import WorkOrderBase from "./WorkOrderBase";

export const WorkOrder = ({ id, sx = {}, baseProps = {}, enabled, data }) => {
  const hasInjectedData = data !== undefined;
  const query = useGetWorkOrderData(id, enabled && !hasInjectedData);
  const refetchData = useDebounce(query?.refetch ?? (() => {}), 500);

  useEffect(() => {
    if (!hasInjectedData) refetchData();
  }, [id, hasInjectedData]);

  const resolvedData = hasInjectedData ? data : query?.data;
  const isLoading = hasInjectedData ? false : query?.isLoading;
  const isError = hasInjectedData ? false : query?.isError;
  if (isError) return null;

  return (
    <WorkOrderBase
      isLoading={isLoading}
      data={resolvedData}
      sx={sx}
      {...baseProps}
    />
  );
};

export default WorkOrder;
